import {
    CREATE_PRINTING_DC2_DETAILS_FAILURE_DK,
    CREATE_PRINTING_DC2_DETAILS_REQUEST_DK,
    CREATE_PRINTING_DC2_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_PRINTING_DC2_DETAILS_DK,
    DELETE_PRINTING_DC2_DETAILS_FAILURE_DK,
    DELETE_PRINTING_DC2_DETAILS_REQUEST_DK,
    DELETE_PRINTING_DC2_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_PRINTING_DC2_DETAILS_FAILURE_DK,
    FETCH_SINGLE_PRINTING_DC2_DETAILS_REQUEST_DK,
    FETCH_SINGLE_PRINTING_DC2_DETAILS_SUCCESS_DK,
    FETCH_PRINTING_DC2_DETAILS_FAILURE_DK,
    FETCH_PRINTING_DC2_DETAILS_REQUEST_DK,
    FETCH_PRINTING_DC2_DETAILS_SUCCESS_DK,
    PRINTING_DC2_DETAILS_USERFORM_RESET_DK,
    UPDATE_PRINTING_DC2_DETAILS_FAILURE_DK,
    UPDATE_PRINTING_DC2_DETAILS_REQUEST_DK,
    UPDATE_PRINTING_DC2_DETAILS_SUCCESS_DK,
    FETCH_PRINTING_DC2_DETAILS_BY_ID_REQUEST_DK,
    FETCH_PRINTING_DC2_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_PRINTING_DC2_DETAILS_DC_NO_REQUEST_DK_DK,
    FETCH_PRINTING_DC2_DETAILS_DC_NO_SUCCESS_DK_DK,
    FETCH_PRINTING_DC2_DETAILS_DC_NO_FAILURE_DK_DK,
    FETCH_GRN_NO_BY_PRINTING_DC2_NO_REQUEST_DK_DK,
    FETCH_GRN_NO_BY_PRINTING_DC2_NO_SUCCESS_DK_DK,
    FETCH_GRN_NO_BY_PRINTING_DC2_NO_FAILURE_DK_DK,
    FETCH_PRINTING_DC2_DETAILS_PROGRAM_REQUEST_DK,
    FETCH_PRINTING_DC2_DETAILS_PROGRAM_SUCCESS_DK,
    FETCH_PRINTING_DC2_DETAILS_PROGRAM_FAILURE_DK,
    FETCH_PRINTING_DC2_DETAIL_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_PRINTING_DC2_DETAIL_EDIT_QUANTITY_REQUEST_DK,
    FETCH_PRINTING_DC2_DETAIL_EDIT_QUANTITY_FAILURE_DK,
    CREATE_PRINTING_DC2_DETAIL_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_PRINTING_DC2_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_PRINTING_DC2_DETAIL_EDIT_QTY_MASTER_FAILURE_DK,
    CREATE_USER_FORM_PRINTING_DC2_EDIT_QTY_DK,
    RESET_PRINTING_DC2_EDIT_QTY_DK
} from './printingDC2Details.actionsType';

export const PRINTING_DC2_DETAILS_DK = 'printingDc2DetailsDK';

let initialState = {
    loading: false,
    printingDC2DetailsById: [],
    printingDC2Details: [],
    printingDC2DetailsDcNo: [],
    grnNoByPrintingDc2No: [],
    editPrintingQtyList: [],
    printingDC2DetailsProgram: [],
    userform: {
        fldFKRatePerPCs: 0,
        // fldFKSKUDetail: [],
        fldQuantity: 0,
        fldFKNoofRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKSKUDetail: []
    },
    selectedPrintingDC2Details: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let printingDC2DetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PRINTING_DC2_DETAILS_REQUEST_DK:
        case FETCH_PRINTING_DC2_DETAIL_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_PRINTING_DC2_DETAILS_PROGRAM_REQUEST_DK:
        case FETCH_GRN_NO_BY_PRINTING_DC2_NO_REQUEST_DK_DK:
        case FETCH_PRINTING_DC2_DETAILS_DC_NO_REQUEST_DK_DK:
        case FETCH_PRINTING_DC2_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_PRINTING_DC2_DETAILS_REQUEST_DK:
        case CREATE_PRINTING_DC2_DETAIL_EDIT_QTY_MASTER_REQUEST_DK:
        case FETCH_SINGLE_PRINTING_DC2_DETAILS_REQUEST_DK:
        case UPDATE_PRINTING_DC2_DETAILS_REQUEST_DK:
        case DELETE_PRINTING_DC2_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC2_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC2Details: updatePayload
            };
        case FETCH_PRINTING_DC2_DETAIL_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: updatePayload
            };
        case FETCH_PRINTING_DC2_DETAILS_PROGRAM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC2DetailsProgram: updatePayload?.Program
            };
        case FETCH_PRINTING_DC2_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC2DetailsById: updatePayload
            };
        case FETCH_GRN_NO_BY_PRINTING_DC2_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                grnNoByPrintingDc2No: updatePayload?.Inward
            };
        case CREATE_PRINTING_DC2_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: updatePayload?.CUD
            };
        case CREATE_PRINTING_DC2_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: [],
                userform: {
                    ...state.userform,
                    InwardNO: []
                }
            };
        case RESET_PRINTING_DC2_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: []
            };
        case FETCH_PRINTING_DC2_DETAILS_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                printingDC2DetailsDcNo: updatePayload?.PRPD
            };
        case FETCH_SINGLE_PRINTING_DC2_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDC2Details: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_PRINTING_DC2_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDC2Details: {},
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                }
            };
        case DELETE_PRINTING_DC2_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedPrintingDC2Details: {}
            };

        case FETCH_PRINTING_DC2_DETAILS_FAILURE_DK:
        case FETCH_PRINTING_DC2_DETAIL_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_PRINTING_DC2_DETAILS_PROGRAM_FAILURE_DK:
        case FETCH_PRINTING_DC2_DETAILS_DC_NO_FAILURE_DK_DK:
        case FETCH_GRN_NO_BY_PRINTING_DC2_NO_FAILURE_DK_DK:
        case FETCH_SINGLE_PRINTING_DC2_DETAILS_FAILURE_DK:
        case CREATE_PRINTING_DC2_DETAILS_FAILURE_DK:
        case CREATE_PRINTING_DC2_DETAIL_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_PRINTING_DC2_DETAILS_FAILURE_DK:
        case DELETE_PRINTING_DC2_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PRINTING_DC2_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_PRINTING_DC2_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                // userform: {
                //     ...state.userform
                // },
                editPrintingQtyList: payload
            };
        case PRINTING_DC2_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedPrintingDC2Details: {}
            };
        default:
            return state;
    }
};
